export const ROUTE_NAMES = {
  Product: 'Product',
  TYP: 'TYP',
  Orders: 'AccountOrders',
  Main: 'Main',
  MainPage: 'MainPage',
  Category: 'Category',
  Search: 'Search',
  Checkout: 'Checkout',
  AccountClub: 'AccountClub',
  AccountFavorites: 'AccountFavorites',
  AccountProfile: 'AccountProfile',
  AccountBlock: 'AccountBlock',
  ContentLandingPages: 'ContentLandingPages',
} as const;
